import * as React from 'react';
import {connect} from 'react-redux';
import {Card} from "antd";
import {ApplicationState, ConnectedReduxProps} from '@reducers/index';
import TableRenderer from "@hocs/TableRenderer";
import {Ticket} from '@models/ticket';
import {fetchRequest, updateRequest} from '@actions/ticket';
import TicketsTable from "@components/tickets/Table";
import {getTicketsList} from '@reducers/ticket';
import SearchTicketsComponent from "@components/tickets/Search";

interface PropsFromState {
    loading: boolean
    data: Ticket[]
    errors?: string,
    count: number
}

interface PropsFromDispatch {
    fetchRequest: typeof fetchRequest
    updateRequest: typeof updateRequest
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps


class TicketIndexPage extends React.Component<AllProps> {

    render() {
        const {loading, data, search, currentPage, updateRequest, pendingTickets} = this.props;
        return (
            <div>
                <div className={'page-table-wrapper'}>
                    <Card bordered={false} className={`page-table-header search-part`}>
                        <SearchTicketsComponent search={search}/>
                    </Card>

                    <TicketsTable data={data}
                                  currentPage={currentPage}
                                  rowKey={record => record.id}
                                  updateRequest={updateRequest}
                                  pendingTickets={pendingTickets}
                                  loading={loading}/>
                </div>
            </div>
        )
    }
}

const mapStateToProps = ({tickets}: ApplicationState) => {
    return {
        loading: tickets.loading,
        errors: tickets.errors,
        data: getTicketsList(tickets),
        count: tickets.count,
        pendingTickets: tickets.pendingTickets
    }
};

const mapDispatchToProps = {
    fetchRequest,
    updateRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(TableRenderer(TicketIndexPage));

